// @flow

import type {ApplicationState} from '../../types'
import type {PlaceState} from '../types'

export function getPagination(appState: ApplicationState): ?PaginationResponse<PartnerPlace>{
  return _getPagination(appState.place) 
}

function _getPagination(state: PlaceState): ?PaginationResponse<PartnerPlace>{
  return state.pagination
}

getPagination.internal = _getPagination
